/**
* Site bar alert
*/
export function siteBarAlertInit() {
   const siteBarAlert = document.getElementById('js-site-bar-alert');
   if (siteBarAlert) {
       siteBarAlert.addEventListener('closed.bs.alert', function () {
           document.querySelector('body').classList.remove('site__bar--active');

           const bannerId = siteBarAlert.getAttribute('data-banner');

           if (bannerId) {
               const date = new Date();
               date.setDate(date.getDate() + 1);
               document.cookie = 'so_header_alert=' + bannerId + '; path=/; expires=' + date.toGMTString();
           }
       });
   }
}